import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";

import { MapContainer, TileLayer } from "react-leaflet";
import Markers from "./Markers";
import NewFoodMarkers from "./NewFoodMarkers";
import Popup from "./Popup";
import UserLocation from "./UserLocation";

import { Sizes } from "../../../styles";

// the main Map component
// tile layer controls the visual map layer. Can be changed with a mapbox map or other providers
// Markers render dynamically based on which category is selected
// Popup actually doesn't show anything. It helps to pan to a selected location
// Userlocation finds the user's current location

const Map = ({ centre, isNewFood }) => {
	const isDesktop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	const mapArgs = {
		center: centre,
		zoom: 16,
		locate: { watch: true },
		zoomControl: false,
	};

	const styles = {
		height: "100%",
		width: "100vw",
		position: isDesktop ? "absolute" : "relative",
	};

	return (
		<MapContainer style={styles} {...mapArgs}>
			<TileLayer
				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url="https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png"
			/>
			{isNewFood? <NewFoodMarkers/> : <Markers />}
			<Popup />
			<UserLocation />
		</MapContainer>
	);
};

Map.propTypes = {
	centre: PropTypes.array,
	isNewFood: PropTypes.bool,
}; 

export default Map;
